export const API_ENDPOINTS = {
    CONTACT_US:"/web/submitContactUs",
    SUBSCRIBE_NEWSLETTER:"/web/newsletter",
    REGISTER_MERCHENT_INFO:"auth/register",
    REGISTER_MERCHENT_IMAGE:"auth/uploadFile"
}